// #genai shared startup actions
export const SET_SHARED_CONTEXT = 'SHARED_STARTUP/SET_SHARED_CONTEXT';
export const SET_SHARED_ACCESS = 'SHARED_STARTUP/SET_SHARED_ACCESS';
export const SET_SHARED_PHASE = 'SHARED_STARTUP/SET_SHARED_PHASE';
export const RESET_SHARED = 'SHARED_STARTUP/RESET_SHARED';

export const setSharedContext = (payload) => ({
  type: SET_SHARED_CONTEXT,
  payload,
});

export const setSharedAccess = (payload) => ({
  type: SET_SHARED_ACCESS,
  payload,
});

export const setSharedPhase = (payload) => ({
  type: SET_SHARED_PHASE,
  payload,
});

export const resetShared = () => ({
  type: RESET_SHARED,
});
